import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const LOCATIONS = ['Austin, TX', 'Miami, FL', 'Phoenix, AZ', 'Seattle, WA', 'Denver, CO', 'Portland, OR', 'Nashville, TN', 'San Diego, CA'];
const TIME_AGO = ['Just now', '2 minutes ago', '5 minutes ago', '12 minutes ago', 'Just now'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [location, setLocation] = useState(LOCATIONS[0]);
  const [time, setTime] = useState(TIME_AGO[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const interval = setInterval(() => {
      setIsVisible(false);
      // Wait for exit animation then show new one
      setTimeout(() => {
        const randomLocation = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
        const randomTime = TIME_AGO[Math.floor(Math.random() * TIME_AGO.length)];
        setLocation(randomLocation);
        setTime(randomTime);
        setIsVisible(true);
      }, 2000); // Time between popups
    }, 20000 + Math.random() * 15000); // Random duration between 20-35s
    return () => clearInterval(interval);
  }, [isVisible]);
  return <AnimatePresence data-id="element-32">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full" data-id="element-33">
          <div className="bg-white/90 backdrop-blur-md border border-gray-200 rounded-2xl shadow-lg p-3 flex items-center gap-3" data-id="element-34">
            <div className="flex-shrink-0 w-12 h-12 bg-gray-100 rounded-xl overflow-hidden border border-gray-100" data-id="element-35">
              <img src="https://cdn.magicpatterns.com/uploads/nhv8YVLMYTydfx6FYY8fXH/heylloyd-image-1771525709435.png" alt="Product thumbnail" className="w-full h-full object-cover" data-id="element-36" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-37">
              <p className="text-sm font-medium text-gray-900 leading-tight" data-id="element-38">
                Someone in {location} just purchased
              </p>
              <p className="text-xs text-teal-600 font-medium mt-0.5" data-id="element-39">
                Anxiety Off Switch™
              </p>
              <p className="text-[10px] text-gray-400 mt-0.5" data-id="element-40">{time}</p>
            </div>
            <div className="flex-shrink-0 text-teal-500" data-id="element-41">
              <CheckCircle2Icon className="w-5 h-5" data-id="element-42" />
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}